export const FUND_DESIGNATIONS = [
    {value: 'EQQYAZNL', label: 'General Fund'},
    {value: 'EX2V72QE', label: 'International Literature Fund'}
];

export const BASE_URL = 'https://contribute.adultchildren.org/page/FUNYAJSDLJU';
